export default __webpack_public_path__ + "static/media/Judgement.7baf882c.jpg";